<template>
  <div>
   <!-- <filter-bar name="roles" :pSearch="search"></filter-bar>-->
    <div class="min-h-screen flex-1 mt-1 bg-gray-100  items-center">
      <div class="bg-white w-fullrounded-lg shadow overflow-hidden">
        <div class="h-20 py-3 flex items-center border-gray-200 p-6">
          <div class="flex">
            <div class="text-2xl font-bold text-blue-600">roles</div>
          </div>
          <div class="w-full flex justify-end">
            <router-link
              class="flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
              to="/roles/new"
            >
              <i class="material-icons">add</i> add Role
            </router-link>
          </div>
        </div>

        <div>
          <base-table
            :refresh="refresh"
            :content="contentRole"
            :headers="headersRole"
            :idWharhouse="idWharhouse" 
            :currentUser="currentUser"
            name="roles"
          >
          </base-table>
        </div>

        <div class="p-10"></div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      headersRole: ["name", "description"],
      contentRole: [],
      roles: [],
    };
  },
  async mounted() {
    await this.getRoles();
  },
  methods: {
    async refresh() {
      await this.getRoles();
    },
    async search(data) {
      const filter = {
        name: data,
      };
      //console.log(data);
      const res = await this.$server.find("roles", filter);
      //console.log(res);
      if (res && res.content) this.contentRole = res.content;
      else this.contentRole = [];
    },

    /*********************************** Roles  **************************************/
    async getRoles() {
      const res = await this.$server.search("roles");
      if (res.content.results) {
        this.contentRole = res.content.results;
      } else this.contentRole = [];
      //console.log(this.contentRole);
    },
  },
};
</script>

<style>
</style>




